import { get, post } from './ApiService'; // <-- Added 'post' import here
import { ServerEndpoint } from "../Redux/endpoints.ts";

const SystemDataService = {
    async getSystemContent() {
        try {
            const res = await get(ServerEndpoint.SYSTEM_CONTENT);
            return res?.data?.data || {};
        } catch (error) {
            console.error('Failed to fetch system data:', error);
            return {};
        }
    },

    async getPopUpImage() {
        try {
            const res = await get(ServerEndpoint.POP_UP_IMAGE);
            return res?.data?.data || {};
        } catch (error) {
            console.error('Failed to fetch system data:', error);
            return {};
        }
    },

    async getCarouselImages() {
        try {
            const res = await get(ServerEndpoint.CAROUSEL_IMAGES);
            return res?.data?.data || [];
        } catch (error) {
            console.error('Failed to fetch carousel images:', error);
            return [];
        }
    },

    async getPartnersImages() {
        try {
            const res = await get(ServerEndpoint.PARTNERS_IMAGES);
            return res?.data?.data || [];
        } catch (error) {
            console.error('Failed to fetch carousel images:', error);
            return [];
        }
    },

    async getSpecialsImages() {
        try {
            const res = await get(ServerEndpoint.SPECIALS_IMAGES);
            return res?.data?.data || [];
        } catch (error) {
            console.error('Failed to fetch specials images:', error);
            return [];
        }
    },

    async getCategories() {
        try {
            const res = await get(ServerEndpoint.CATEGORIES);
            return res?.data?.data || [];
        } catch (error) {
            console.error('Failed to fetch content categories:', error);
            return [];
        }
    },

    async getCategoryBySlug(slug) {
        try {
            const res = await get(`${ServerEndpoint.CATEGORIES}/${slug}`);
            return res?.data?.data || [];
        } catch (error) {
            console.error('Failed to fetch category by slug:', error);
            return [];
        }
    },

    async getProductAttributes() {
        try {
            const res = await get(ServerEndpoint.CONTENT_PRODUCT_ATTRIBUTES);
            return res?.data?.data || [];
        } catch (error) {
            console.error('Failed to fetch product attributes:', error);
            return [];
        }
    },

    async getGalleryImages() {
        try {
            const res = await get(ServerEndpoint.GALLERY_IMAGES);
            return res?.data?.data || [];
        } catch (error) {
            console.error('Failed to fetch gallery images:', error);
            return [];
        }
    },

    async getCardInfo() {
        try {
            const res = await get(ServerEndpoint.CONTENT_CARD_INFO);
            return res?.data?.data || [];
        } catch (error) {
            console.error('Failed to fetch gallery images:', error);
            return [];
        }
    },

    async getReviews() {
        try {
            const res = await get(ServerEndpoint.CONTENT_REVIEWS);
            return res?.data?.data || [];
        } catch (error) {
            console.error('Failed to fetch gallery images:', error);
            return [];
        }
    },

    // One call that returns the whole landing payload (language meta + core
    // content), replacing the banners/links/categories/services/business-info
    // request waterfall on first load.
    async getBootstrap() {
        try {
            const res = await get(ServerEndpoint.BOOTSTRAP);
            return res?.data?.data || {};
        } catch (error) {
            console.error('Failed to fetch bootstrap:', error);
            return {};
        }
    },

    async getGeoLanguage() {
        try {
            const res = await get(ServerEndpoint.GEO_LANGUAGE);
            return res?.data?.data || {};
        } catch (error) {
            console.error('Failed to fetch geo language:', error);
            return {};
        }
    },

    async getBannerMessages() {
        try {
            const res = await get(ServerEndpoint.CONTENT_BANNER);
            return res?.data?.data || [];
        } catch (error) {
            console.error('Failed to fetch banner messages:', error);
            return [];
        }
    },

    async getLinks() {
        try {
            const res = await get(ServerEndpoint.CONTENT_LINKS);
            return res?.data?.data || [];
        } catch (error) {
            console.error('Failed to fetch content links:', error);
            return [];
        }
    },

    async getServicesData() {
        try {
            const res = await get(ServerEndpoint.SERVICES_DATA);
            return res?.data?.data || [];
        } catch (error) {
            console.error('Failed to fetch services data:', error);
            return [];
        }
    },

    // Single round-trip for the ClearViolations home page — all sections at once.
    async getHomeData() {
        try {
            const res = await get(ServerEndpoint.HOME_DATA);
            return res?.data?.data || null;
        } catch (error) {
            console.error('Failed to fetch home data:', error);
            return null;
        }
    },

    async getServicesDataBySlug(slug) {
        try {
            const res = await get(`${ServerEndpoint.SERVICES_DATA}/${slug}`);
            return res?.data?.data || [];
        } catch (error) {
            console.error('Failed to fetch services data by slug:', error);
            return [];
        }
    },

    async getLocationsData() {
        try {
            const res = await get(ServerEndpoint.LOCATIONS_DATA);
            return res?.data?.data || [];
        } catch (error) {
            console.error('Failed to fetch locations data:', error);
            return [];
        }
    },

    async getLocationsDataBySlug(slug) {
        try {
            const res = await get(`${ServerEndpoint.LOCATIONS_DATA}/${slug}`);
            return res?.data?.data || [];
        } catch (error) {
            console.error('Failed to fetch location data:', error);
            return [];
        }
    },

    async getProjectsData() {
        try {
            const res = await get(ServerEndpoint.PROJECTS_DATA);
            return res?.data?.data || [];
        } catch (error) {
            console.error('Failed to fetch projects data:', error);
            return [];
        }
    },

    async getBlogsData() {
        try {
            const res = await get(ServerEndpoint.BLOGS_DATA);
            return res?.data?.data || [];
        } catch (error) {
            console.error('Failed to fetch blogs data:', error);
            return [];
        }
    },

    async getBlogBySlug(slug) {
        try {
            const res = await get(`${ServerEndpoint.BLOGS_DATA}/${slug}`);
            return res?.data?.data || null;
        } catch (error) {
            console.error('Failed to fetch blog by slug:', error);
            return null;
        }
    },

    async getProjectsDataBySlug(slug) {
        try {
            const res = await get(`${ServerEndpoint.PROJECTS_DATA}/${slug}`);
            return res?.data?.data || [];
        } catch (error) {
            console.error('Failed to fetch project data:', error);
            return [];
        }
    },

    async getEventsData() {
        try {
            const res = await get(ServerEndpoint.EVENTS_DATA);
            return res?.data?.data || [];
        } catch (error) {
            console.error('Failed to fetch events data:', error);
            return [];
        }
    },

    async getEventBySlug(slug) {
        try {
            const res = await get(`${ServerEndpoint.EVENTS_DATA}/${slug}`);
            return res?.data?.data || null;
        } catch (error) {
            console.error('Failed to fetch event by slug:', error);
            return null;
        }
    },

    async getPolicies() {
        try {
            const res = await get(ServerEndpoint.POLICIES);
            return res?.data?.data || [];
        } catch (error) {
            console.error('Failed to fetch policies:', error);
            return [];
        }
    },

    async getBusinessInfo() {
        try {
            const res = await get(ServerEndpoint.BUSINESS_INFO);
            return res?.data?.data || [];
        } catch (error) {
            console.error('Failed to fetch content business info:', error);
            return [];
        }
    },

    async getAllActiveLocations() {
        try {
            const res = await get(ServerEndpoint.CONTENT_LOCATIONS);
            return res?.data?.data || [];
        } catch (error) {
            console.error('Failed to fetch content buisness info:', error);
            return [];
        }
    },

    async getCardFaq() {
        try {
            const res = await get(ServerEndpoint.CONTENT_FAQ_INFO);
            return res?.data?.data || [];
        } catch (error) {
            console.error('Failed to fetch gallery images:', error);
            return [];
        }
    },

    byLabel(links, label) {
        return (links || []).find((l) => (l.label || '').toLowerCase() === label.toLowerCase()) || {};
    },

    courierLogoUrl(links, courierFamily = '', fallbackUrl = '') {
        const f = (courierFamily || '').toLowerCase();
        if (f.includes('fedex')) return this.byLabel(links, 'FedEx Logo')?.image || fallbackUrl || null;
        if (f.includes('ups'))   return this.byLabel(links, 'UPS Logo')?.image   || fallbackUrl || null;
        if (f.includes('dhl'))   return this.byLabel(links, 'DHL Logo')?.image   || fallbackUrl || null;
        if (f.includes('usps'))  return this.byLabel(links, 'USPS Logo')?.image  || fallbackUrl || null;
        return fallbackUrl || null;
    },

    /**
     * Returns a resolved courier info object from an order's shippingRate + system data links.
     * Returns null if the order has no delivery / no shippingRate.
     *
     * Usage:
     *   const courierInfo = SystemDataService.courierInfo(links, order);
     *   // { name, logoUrl, transitDays, cost }
     */
    courierInfo(links, order) {
        if (!order?.includeDelivery || !order?.shippingRate) return null;
        const rate   = order.shippingRate;
        const family = rate.courierFamily || rate.serviceLabel || '';
        const f      = family.toLowerCase();

        const DISPLAY = { fedex: 'FedEx', ups: 'UPS', dhl: 'DHL', usps: 'USPS' };
        const match   = Object.keys(DISPLAY).find(c => f.includes(c));
        const name    = match ? DISPLAY[match] : (rate.serviceLabel || 'Delivery');
        const logoUrl = this.courierLogoUrl(links, family, rate.courierLogoUrl || '');

        return { name, logoUrl, transitDays: rate.transitDays || null, cost: rate.cost || null };
    },

    async getByPath(path) {
        try {
            const endpoint = ServerEndpoint.SYSTEM_DATA;
            const res = await post(endpoint, { path });
            return res?.data?.data || [];
        } catch (error) {
            console.error(`Failed to fetch system data by path: ${path}`, error);
            return [];
        }
    },


    async uploadMedia(file) {
        try {
            const endpoint = ServerEndpoint.UPLOAD_MEDIA;
            const res = await post(endpoint, {}, true, 'Uploading media...', [file]);

            if (res?.data?.data?.url) {
                return res.data.data.url;
            }

            return res?.data?.data || null;
        } catch (error) {
            console.error('Failed to upload media:', error);
            throw error;
        }
    },

    // Upload several files in a single request; returns an array of URLs (in the
    // order the files were provided). Falls back to the single `url` if the
    // backend only returned one.
    async uploadMediaMany(files) {
        const list = Array.from(files || []).filter(Boolean);
        if (!list.length) return [];
        try {
            const endpoint = ServerEndpoint.UPLOAD_MEDIA;
            const res = await post(endpoint, {}, true, `Uploading ${list.length} files...`, list);
            const data = res?.data?.data;
            if (Array.isArray(data?.urls)) return data.urls.filter(Boolean);
            if (data?.url) return [data.url];
            return [];
        } catch (error) {
            console.error('Failed to upload media (batch):', error);
            throw error;
        }
    }
};

export default SystemDataService;